import {
	type UseMutationOptions,
	useMutation,
	useQueryClient
} from '@tanstack/react-query'
import { QUERY_KEYS } from '@/query-client'
import {
	type HttpEditStepOptions,
	httpEditStep
} from '../http/experience-shell.http'
import type { Experience } from '../types'

export const useEditStep = ({
	experienceId,
	options
}: {
	experienceId: number
	options?: Omit<
		UseMutationOptions<
			Experience,
			unknown,
			HttpEditStepOptions['urlParams']['stepKeyName']
		>,
		'mutationFn'
	>
}) => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (stepKeyName) =>
			httpEditStep({
				urlParams: { experienceId, stepKeyName },
				params: { responseType: 'extended' }
			}),
		...options,
		onSuccess: (data, variables, onMutateResult, context) => {
			queryClient.cancelQueries({
				queryKey: [QUERY_KEYS.EXPERIENCE, experienceId]
			})
			queryClient.setQueriesData(
				{ queryKey: [QUERY_KEYS.EXPERIENCE, experienceId] },
				data
			)
			options?.onSuccess?.(data, variables, onMutateResult, context)
		}
	})
}
